import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { ProductionFloorNodeModel } from './ProductionFloorNodeModel';
import { ProductionFloorNodeWidget } from './ProductionFloorNodeWidget';

export class ProductionFloorNodeFactory extends AbstractReactFactory {
  isMainMap: boolean;

  constructor(isMainMap: boolean) {
    super(NodeModelTypeEnum.ProductionFloor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new ProductionFloorNodeModel();
  }

  nodeUI(event) {
    return <ProductionFloorNodeWidget engine={this.engine} node={event.model} width={149} height={198} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
